import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Image from "components/image";
// Images for animals in the collection grid

// Bulk image album
import archiveBrb2 from "img/brbs/BRB004a.jpg";
import archiveBrb4 from "img/brbs/20181229-scan405-3.jpg";
import collectionMeta from "content/collections/bullsnakes.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const Bullsnakes = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Bullsnakes (Pituophis catenifer sayi)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/bullsnakes" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        Bullsnakes are <i>very</i> new to me. I have been interested in them for years
        but I admit, the pair that I have kind of came to me unexpectedly. I was selling 
        baby snakes and 
        a person approached me with an offer to get the whitesided hypo female that you
        see in the pictures on this page. They also offered me the male albino. Turns out
        that made it an easy decision.
      </BodyText>
      <BodyText>
        I see the Hannum hypo bullsnakes that are out there and if I can make room for just one
        more snake I may add one of those too, but so far I love what I have.
      </BodyText>
      <BodyText>
        The bullsnakes have been a blast to keep and they are both so beautiful,
        but the female I've named Tempest because she definitely brings the bullsnake
        attitude with her. Once she's agitated - which seems to happen just by me looking
        at her - then she starts the loud hissing that they are so known for. It's kind
        of terrifying if you are used to a room full of quiet snakes! Even when she's back
        in her cage and the glass doors are closed her hissing is quite loud.
      </BodyText>
      <BodyText>
        But I'm fine with some attitude and I'm sure she and I will just become friends in
        our own special way.
      </BodyText>
      <BodyText>
        I'll add husbandry information as I get more experience with them.
      </BodyText>

      <PageGallery slug="bullsnakes" maxWidth="900" />
    </ContentBox>
  );
};

export default Bullsnakes;
